module.exports = __webpack_public_path__ + "img/Telefónica_2021_logo.svg.37103366.png";